package org.hs_soft.runmynesto.pages.home.mvi

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs.DataAssistantLogsModel
import org.hs_soft.runmynesto.domain.model.home.home.global_search.GlobalSearch
import org.hs_soft.runmynesto.domain.model.home.home.hssoft_apps_list.HSWebApps
import org.hs_soft.runmynesto.domain.model.home.home.user_profile_info.GetUserProfileData
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model.ChatMessageHistoryModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.model.menu.MenuItemsEnum

data class HomeState(
    val activePage: MenuItemsEnum = MenuItemsEnum.DASHBOARD,
    val selectedLanguage:String?=null,
    val globalSearchList:List<GlobalSearch?>?=null,
    val idToken:String?=null,
    val errorInfo:String?=null,
    val listOfHSSortsApps:List<HSWebApps?> ?=null,
    val showSettingDialog:Boolean=false,
    val showApplications:Boolean=false,
    val isMenuExpandedHorizontally:Boolean=false,
    val profileInfo: GetUserProfileData?= null,
    val username: String = "",
    val password: String = "",
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val loginSuccessful: Boolean = false,
    val showSearchBarInMobileMode:Boolean=false,
    val windowSizeMode: WindowSizeModeEnum = WindowSizeModeEnum.Desktop,
    val isNewCustomer:Boolean=false,
    val areTabsClickable:Boolean=true,
    val showDataAssistantDialog:Boolean=false,
    val showDataAssistantIcon:Boolean=true,
    val answerAIGeneratorQuestion: String="",
    val messageHistory: ChatMessageHistoryModel = ChatMessageHistoryModel(
        chatMessageHistory = mutableListOf(),
        favoriteMessages = mutableListOf()
    ),
    val userFavoriteMessagesVisible: Boolean = false,
    val isDataAssistantAIGeneratorLoading:Boolean=false,
    val sendQuestionButtonIsClickable:Boolean=true,
    val speechLanguage:String?=null,
    val logLanguage:String?=null,
    val virtualCardInfo: GetVirtualCardConfig?=null,
    val loadingProgress:Boolean=false,
    val isDataAssistantDatabaseLoading:Boolean=false,
    val cashList: List<Children> ?= null,
    val dataAssistantRequestLogs: DataAssistantLogsModel = DataAssistantLogsModel(
        message = null,
        answer = null,
        isGenerating = null,
        audioUrl = null
    ),
    val freeCredits: Long? = null,
    val premiumCredits: Long? = null,
    val userInfoVisible: Boolean = false,
    val moreMenuVisible: Boolean = false,
    val inputBarVisible: Boolean = true,
)